export default function TrustScoreRing({ score = 0, size = 200, animate = true }) {
  const safe = typeof score === "number" ? Math.max(0, Math.min(100, score)) : 0;
  const radius = 90;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (safe / 100) * circumference;

  let color = "#10B981"; // safe
  let label = "Excellent";
  if (safe < 60) {
    color = "#EF4444";
    label = "High Risk";
  } else if (safe < 80) {
    color = "#F59E0B";
    label = "Needs Work";
  }

  return (
    <div
      className={`inline-flex flex-col items-center ${animate ? "ring-animate" : ""}`}
      data-testid="trust-score-ring"
      style={{ width: size }}
    >
      <svg width={size} height={size} viewBox="0 0 200 200" className="-rotate-90">
        <circle cx="100" cy="100" r={radius} fill="none" stroke="#E2E8F0" strokeWidth="14" />
        <circle
          cx="100"
          cy="100"
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="14"
          strokeLinecap="butt"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className="value"
          style={{ transition: "stroke-dashoffset 1.2s ease-out" }}
        />
      </svg>
      <div className="-mt-[60%] flex flex-col items-center pointer-events-none">
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#475569]">
          TrustScore™
        </div>
        <div
          className="font-display text-6xl leading-none tracking-tight mt-1"
          data-testid="trust-score-value"
        >
          {safe}
        </div>
        <div className="font-mono text-xs uppercase tracking-widest mt-1" style={{ color }}>
          {label}
        </div>
      </div>
    </div>
  );
}
